<template>
  <q-page padding>
    <div class="relative-position loader">
      <div class="row">
        <div class="col-12">
          <q-card class="md-card q-mt-lg q-pa-lg relative-position" color="white" text-color="black">
            <q-card-title>
              Helpful Links for Constant Contact
            </q-card-title>
            <q-card-separator/>
            <q-card-main>
              <q-list highlight>
                <q-item>
                  <q-item-side>
                    <q-item-tile icon="link" color="primary"/>
                  </q-item-side>
                  <q-item-main>
                    <q-btn @click="openLink('https://www.constantcontact.com/')" flat color="primary"> Visit Constant
                      Contact
                    </q-btn>
                  </q-item-main>
                </q-item>
                <q-item>
                  <q-item-side>
                    <q-item-tile icon="link" color="primary"/>
                  </q-item-side>
                  <q-item-main>
                    <!--                    <q-btn @click="sendCampaign" flat color="primary"> Send Email Campaign for users to update their profiles</q-btn>-->
                    <q-btn label="Send Profile Update Email to:" flat color="primary">
                      <!-- dropdown content -->
                      <q-popover>
                        <q-list separator link>
                          <q-item
                            @click.native="sendCampaign(['[WEBSITE] Affiliate', '[WEBSITE] General Contractor', '[WEBSITE] Specialty Contractor'])"
                            label>All (Affiliates, General Contractors, Specialty Contractors)>
                          </q-item>
                          <q-item @click.native="sendCampaign(['[WEBSITE] Affiliate'])">
                            Affiliates
                          </q-item>
                          <q-item @click.native="sendCampaign(['[WEBSITE] General Contractor'])" label>
                            General Contractors
                          </q-item>
                          <q-item @click.native="sendCampaign(['[WEBSITE] Specialty Contractor'])" label>
                            Specialty Contractors
                          </q-item>
                          <q-item @click.native="sendCampaign(['Test List'])" label>
                            Test List
                          </q-item>
                        </q-list>
                      </q-popover>
                    </q-btn>
                  </q-item-main>
                </q-item>
              </q-list>
            </q-card-main>
          </q-card>
          <q-card class="md-card q-mt-lg q-pa-lg relative-position" color="white" text-color="black">
            <q-card-title>
              Helpful Notes for Constant Contact
            </q-card-title>
            <q-card-separator/>
            <q-card-main>
              <p><strong>The following is a brief explanation of the integration between this application and Constant
                Contact</strong></p>
              <p>Every day at 2:00 a.m., an automated job runs. This job will upload AGC persons who are members to
                Constant Contact. Additionally any person who is related to a Group or Committee that has CC Sync
                enabled will also be uploaded to Constant Contact. Each user has the ability to add or remove themselves
                from the Weekly Updates and Legislative Updates groups via the website and the sync job will respect
                this. The only caveat is if the user Unsubscribes from Constant Contact directly. If they do this, they
                will not be able to add themselves back on the list from the website account profile edit interface.</p>
              <p>Note the above "send an email campaign" will send an email campaign to all persons who are members to
                update their profiles. This button will send a Constant Contact campaign to all persons who are members.
                Within the email, they will receive a notification encouraging them to update their information and a
                temporary link that will automatically log them in to their profile.</p>
              <p>There is a campaign in Constant Contact called <strong>"Profile Update - Base Template [DO NOT
                DELETE]"</strong> at <a
                href="https://ui.constantcontact.com/rnavmap/evaluate.rnav?activepage=ecampaign.view&pageName=ecampaign.view&action=newedit&popin=true&campaign=39c94c32-d178-418d-8d87-89d50c14567a"
                target="_blank">https://ui.constantcontact.com/rnavmap/evaluate.rnav?activepage=ecampaign.view&pageName=ecampaign.view&action=newedit&popin=true&campaign=39c94c32-d178-418d-8d87-89d50c14567a</a>
                that is used for sending this email. It must <strong>only</strong> be edited by a developer and <u>never
                  deleted</u>.</p>
            </q-card-main>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
  import {openURL} from 'quasar'
  import environmentMixin from '../../../mixins/environment'

  export default {
    name: 'ConstantContact',
    mixins: [environmentMixin],
    methods: {
      openLink (link) {
        openURL(link)
      },
      async sendCampaign (lists) {
        console.log('sendCampaign lists', lists)
        if (lists && lists.length) {
          await this.$q.dialog({
            title: 'Confirm Campaign',
            message: 'Please confirm you wish to send the email campaign to the following list(s) asking them to update their profiles. \n' + lists.toString(),
            ok: 'Send',
            cancel: 'Cancel'
          })
          try {
            await this.$axios.post('/api/constantcontact/sendprofileupdateemail', {
              lists: lists,
              validateStatus: function (status) {
                return status === 200
              }
            })
            this.$q.notify({
              type: 'positive',
              message: 'Campaign has been scheduled and will be sent shortly'
            })
          } catch (e) {
            this.$q.notify({
              type: 'negative',
              message: 'Campaign could not be sent'
            })
          }
        } else {
          this.$q.notify({
            type: 'negative',
            message: 'No list found.'
          })
        }
      }

    }
  }
</script>

<style scoped>

</style>
